<template>
    <div class="main-wrapper scroll-y custom-scrollbar with-tabs view-about" style="background: #fff">

        <page-title :title="'O aplikacji'" :back="true"></page-title>

        <ion-list>
            <ion-item-group v-for="(item,index) in changelog" :key="index">
                <slide-y-up-transition :duration="400+(index*100)" :delay="200+(index*100)">
                    <ion-item-divider v-show="show" style="padding: 8px 14px">
                        <h6 class="m-0">{{ item.title }}</h6>
                    </ion-item-divider>
                </slide-y-up-transition>
                <slide-y-up-transition group :duration="300" :delay="300">
                    <ion-item v-for="(change,c_index) in item.changes" :key="c_index" v-show="show">
                        <p><b>{{ change.title }}</b></p>
                    </ion-item>
                </slide-y-up-transition>
            </ion-item-group>
        </ion-list>

    </div>
</template>

<script>
    import PageTitle from '@/components/PageTitle.vue';

    export default {
        name: 'About',
        components: { PageTitle },
        data(){
            return {
                show: false,
                changelog: [
                  {
                     title: 'Changelog 1.0.16',
                     changes: [
                       { title: '- optymalizacja' },
                     ]
                    },
                    {
                    title: 'Changelog 1.0.15',
                    changes: [
                      { title: '- tutoriale' },
                      { title: '- cennik' },
                      { title: '- zasady marki Książęce' },
                    ]
                  },
                  {
                    title: 'Changelog 1.0.14',
                    changes: [
                      { title: '- program lojalnościowy na 2023' },
                    ]
                  },
                  {
                    title: 'Changelog 1.0.13',
                    changes: [
                      { title: '- wsparcie dla Android 12' },
                    ]
                  },
                  {
                    title: 'Changelog 1.0.12',
                    changes: [
                      { title: '- katalog produktów' },
                    ]
                  },
                  {
                    title: 'Changelog 1.0.11',
                    changes: [
                      { title: '- usuwanie konta' },
                      { title: '- zmiany w UX/UI' }
                    ]
                  },
                  {
                    title: 'Changelog 1.0.10',
                    changes: [
                      { title: '- moduł Programu Lojalnościowego' },
                    ]
                  },
                  {
                    title: 'Changelog 1.0.9',
                    changes: [
                      { title: '- foodpairing ksiazece' },
                    ]
                  },
                    {
                        title: 'Changelog 1.0.8',
                        changes: [
                            { title: '- ostatnie poprawki przed pierwszym release' },
                        ]
                    },
                    {
                        title: 'Changelog 1.0.7',
                        changes: [
                            { title: '- skrót "do pobrania" w górnej belce' },
                            { title: '- dołączanie tokenu podczas wylogowania' },
                            { title: '- zapamiętywanie wybranego PH (ASM)' },
                            { title: '- poprawa doładowywania wpisów w piwopedii' },
                            { title: '- zmiany w UX/UI' },
                        ]
                    },
                    {
                        title: 'Changelog 1.0.6',
                        changes: [
                            { title: '- analityka firebase' },
                            { title: '- przekierowania w notyfikacjach' },
                            { title: '- mnóstwo poprawek' },
                        ]
                    },
                    {
                        title: 'Changelog 1.0.5',
                        changes: [
                            { title: '- pierwsze logowanie ASM' },
                            { title: '- wyszukiwanie w PH' },
                            { title: '- nawigacja po kategoriach jako slider' },
                            { title: '- firestore' },
                            { title: '- mnóstwo poprawek i innych zmian UX' },
                        ]
                    },
                    {
                        title: 'Changelog 1.0.4',
                        changes: [
                            { title: '- zmiany UX po testach (3497)' },
                            { title: '- wyłączenie rejestracji' },
                        ]
                    },
                    {
                        title: 'Changelog 1.0.3',
                        changes: [
                            { title: '- osadzenie sklepu Magento (iframe)' },
                            { title: '- ukrycie sklepu (API)' },
                            { title: '- nawigacja zależna od roli' },
                            { title: '- rozwinięcie funkcjonalności (PH/ASM)' },
                        ]
                    },
                    {
                        title: 'Changelog 1.0.2',
                        changes: [
                            { title: '- dodanie notyfikacji wewnętrznych (dzwonek)' },
                            { title: '- rozwinięcie funkcjonalności' },
                        ]
                    },
                    {
                        title: 'Changelog 1.0.1',
                        changes: [
                            { title: '- dodanie notyfikacji Push' },
                            { title: '- rozwinięcie funkcjonalności' },
                            { title: '- przyspieszenie działania' },
                        ]
                    },
                    {
                        title: 'Changelog 1.0.0',
                        changes: [
                            { title: '- ustanowienie pierwszej stabilnej wersji' }
                        ]
                    }
                ]
            }
        },
        mounted(){
            this.show = true;
        }
    }
</script>